
<div>
  <p class="page-title">Service</p>
  <div class="section-wrapper tabletab">
    <np-tabbed>
      <ul class="tabs">
        <li role="tab"  (click)="changeNav()" aria-selected="true">Manage Service</li>
        <li role="tab" aria-selected="false">Add Service</li>
      </ul>

      <div class="tab-content" role="tabpanel" aria-hidden="false">
        <div class="mt-10 mb-10">
          <div class="exportBtnContainer">
            <button (click)="exportToExcel()" class="primary-btn">Export To Excel</button>
          </div>
          <div>
            <p-table
              [value]="serviceData"
              [scrollable]="true"
              scrollHeight="400px"
              [virtualRowHeight]="20"
              styleClass="division-table p-datatable-gridlines"
              id="StyleTable"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th >Service</th>
                  <th >Status</th>
                  <th>Action To Take</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <td>{{ row.ServiceName }}</td>
                  <td>{{ row.status }}</td>
                  <td class="text-center">
                    <button [ngClass]="row.buttonName =='Retire'?'btn-success': 'btn-warning'" (click)="retire(row)">
                      {{ row.buttonName }}
                    </button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>

      <div class="tab-content" role="tabpanel" aria-hidden="true">
        <p class="boldOne">Add a new service to the Operations user interface.</p>
        <p class="errorText" *ngIf="SaveSuccess">
          The item has been successfully added.
        </p>
        <p class="errorText" *ngIf="errorData">Please enter required fields.</p>
        <div class="manage-details-container">
          <div class="section-title boldOne">Enter Service Data</div>
          <div class="partioned-table">
            <div class="row">
              <div class="cell label">Service</div>
              <div class="cell value d-flex">
                <input [(ngModel)]="newServiceName" maxlength="20"/>
                <p class="errorText">* Required</p>
              </div>
            </div>
            <div class="row">
              <div class="cell label">Listing Priority</div>
              <div class="cell value d-flex">
                <input
                [(ngModel)]="ListingPriority"
                type="number"
                (input)="onInput($event)"
                maxlength="3"
              />
              <p class="errorText">* Required</p>
              </div>
            </div>
            <div class="row">
              <div class="cell label"></div>
              <div class="cell value">
                <button
                  value=""
                  (click)="addService()"
                  class="primary-btn"
                >Add New Service</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </np-tabbed>
  </div>
</div>
